import React from 'react';
import '../css/OkasBoxes.css';
import Icon from 'react-icons-kit';
import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import Modal from 'react-modal';

import Cookies from 'js-cookie';
// import OkasBoxesView from './OkasBoxesView';
import SubscriptionView from './SubscriptionView';
import OkasBoxesEdit from './OkasBoxesEdit';
import OkasBoxesAddNew from './OkasBoxesAddNew';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar';
import SearchBar from './SearchBar';
// import SearchBarNew from './SearchBar'; 
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger, Overlay } from 'react-bootstrap'
// import { calculator } from 'react-icons-kit/ionicons';
// import { Hidden, TablePagination } from '@material-ui/core';
import edit from './../assets/images/edit.svg';
import view from './../assets/images/view.svg';
import deleteIcon from './../assets/images/delete.svg';
import Pagination from 'react-bootstrap/Pagination'

import Loader from './Loader';
import { is_allowed } from '../utilitis';

//Subscriptions dashboard page
const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
    backgroundColor: '#EFF3F6'
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});



class Subscriptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenAddSUB: false,
      modalIsOpenAddSUBView: false,
      modalIsOpenAddSUBEdit: false,
      modalIsOpenDeleteSuccess: false,
      noOfParams: [],
      subData: [],
      siData: [],
      actualData: [],
      searchValue: '',
      loader: true,
      assinedBoxesSI: 0,
      assinedBoxesProjects: 0,
      unAssinedBoxes: 0,
      someState: setTimeout(() => {
        if (this.props.redux.auth.searchBarShow) {
          return 'true'
        } else {
          return 'false'
        }
      }, 500),
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      //states for pagination in table
      paginationTable: {
        currentPage: 0,
        pageNeighbours: 2,
        recordPerPage: 10,
        totalRecords: 0,
        recordFirstID: 0,
        recordLastID: 0,
        buttonArray: []
      }

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAddSUB: false
    }, () => {
      this.setState({
        modalIsOpenAddSUB: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddSUB: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }


  ActivateSUBModel = (e) => {
    if (this.state.modalIsOpenAddSUB) {
      return <OkasBoxesAddNew activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  refreshDevices = (e) => {
    this.setState({
      modalIsOpenAddSUB: false,
      modalIsOpenAddSUBView: false,
      modalIsOpenAddSUBEdit: false,
      modalIsOpenDeleteSuccess: false,
    }, () => {
      this.fetchDevices();
    })
  }

  //function for pagination

  paginationFunction = () => {
    // debugger
    console.log('asd')
    let totalButton = (this.state.subData.length / this.state.paginationTable.recordPerPage);
    let emtyArray = Array.apply(null, { length: Math.ceil(totalButton) }).map(Number.call, Number)

    // let emtyArray = new Array(Math.ceil(totalButton)).fill('0');
    this.setState({
      paginationTable: {
        ...this.state.paginationTable,
        buttonArray: emtyArray
      }
    })
  }

  ActivateSUbModelView = (e) => {
    if (this.state.modalIsOpenAddSUBView) {
      return <SubscriptionView activeModal={true} SUbCurrentData={this.state.SUbCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSUbModelEdit = (e) => {
    if (this.state.modalIsOpenAddSUBEdit) {
      return <OkasBoxesEdit activeModal={true} SUbCurrentData={this.state.SUbCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  componentDidMount() {
    this.fetchSI()
    // this.fetchDevices();
    this.resetSearchBar()
  }
  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/okasBoxApi_Detail/${this.state.itemToDeleteId}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.fetchDevices();
        this.setState({
          modalIsOpenDelete: false,
          modalIsOpenDeleteSuccess: true
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }

  fetchDevices = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/subscriptionApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        console.log(data);
        if (!data ||  data.length === 0) {
          this.setState({ loader: false });
          return;
        }

        let subData = data;
        // console.log(subData)
        data.forEach((subElement) => {
          if (subElement.subscription_status === 'expired') {
            this.setState({
              unAssinedBoxes: this.state.unAssinedBoxes + 1
            })
          }
          if (subElement.osubscription_status === 'active') {
            this.setState({
              assinedBoxesSI: this.state.assinedBoxesSI + 1
            })
          }
          if (subElement.subscription_status === 'about_to_expire') {
            this.setState({
              assinedBoxesProjects: this.state.assinedBoxesProjects + 1
            })
          }
        })
        this.setState({
          subData: subData,
          actualData: subData,
          loader: false
        }, () => {
          this.paginationFunction();
        })
        // console.log('subData:',data.all_subscriptions)  
      })
      .catch((err) => {
        console.log(err)
        this.setState({ loader: false });
      })
  }


  restoreData = (data) => {
    this.setState({
      subData: data
    })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.subData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.subData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.subData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.subData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  assignedBoxRender = (status) => {
    if (status === 'expired') {
      return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#be0101', borderRadius: "2.5vh", }}></div>
    } else if (status === 'active') {
      return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#46ad78', borderRadius: "2.5vh", }}></div>
    } else if (status === "about_to_expire") {
      return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#f6a200', borderRadius: "2.5vh", }}></div>
    }
  }


  //  Assign payment render 

  assignedPaymentRender = (paymentStatus) => {
    let textStyle = {};
    if (paymentStatus === 'due') {
      textStyle = { color: '#be0101' }; // Red background for 'due' status
    } else if (paymentStatus === 'complete') {
      textStyle = { color: '#46ad78' }; // Green background for 'complete' status
    } else if (paymentStatus === 'waiting for payment') {
      textStyle = { color: '#f6a200' }; // Orange background for 'about_to_expire' status
    }

    return <div style={textStyle}>{paymentStatus}</div>;
  }


  fetchSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/si_IntegratorApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          siData: data,
        }, () => {
          this.fetchDevices()
        })
        // console.log('siData:',data)
      })

  }

  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  subDatatable = () => {
    if (this.state.subData !== null) {
      let someData = this.state.subData.map((subElement, index) => {
        // console.log(subElement);
        const dateFromString = new Date(subElement.subscription_end_date);
        const dateOnly = dateFromString.toISOString().split('T')[0];
        return <tr key={index} className="some-hover">
          <td scope="col" style={{ width: '30px', }} >{subElement.project_name}</td>
          <td scope="col" style={{ width: '35px', textAlign: 'center' }}>{subElement.Address}</td>
          <td scope="col" style={{ width: '55px' }}>{subElement.client_email}</td>
          <td scope="col" style={{ width: '10%' }}>{subElement.si_name}</td>
          <td scope="col" style={{ width: '60px' }}>{subElement.distributor_email}</td>
          <td scope="col" style={{ width: '50px' }}>{dateOnly}</td>
          <td scope="col" style={{ width: '30px' }}>{this.assignedBoxRender(subElement.subscription_status)}</td>
          <td scope="col" style={{ width: '32px', textTransform: 'uppercase', fontSize: '12px' }} >{this.assignedPaymentRender(subElement.payment_status)}</td>

          <td style={{ width: '10px', textAlign: 'end' }}>
            <span
              // className="fas fa-eye fa-2x pull-right icon-button-si px-2 py-2" 
              onClick={
                (e) => {
                  if (this.state.modalIsOpenAddSUBView) {
                    this.setState({ modalIsOpenAddSUBView: false }, () => {
                      this.setState({
                        modalIsOpenAddSUBView: true,
                        SUbCurrentData: subElement,

                      })
                    })
                  } else {
                    this.setState({
                      modalIsOpenAddSUBView: true,
                      SUbCurrentData: subElement
                    })
                  }
                }}>
              <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} />
            </span>
            <OverlayTrigger
              placement='auto'
              display={false}
              overlay={subElement.subscription_status === 'expired' ? <div></div> : <Tooltip id="overlay-example">Assigned</Tooltip>}>
              <span className="d-inline-block">
                <span
                  style={{ pointerEvents: subElement.subscription_status !== 'expired' ? 'none' : '', opacity: subElement.subscription_status !== 'expired' ? '0.5' : '' }}
                  onClick={
                    (e) => {
                      if (this.state.modalIsOpenAddSUBEdit) {
                        this.setState({ modalIsOpenAddSUBEdit: false }, () => {
                          this.setState({
                            modalIsOpenAddSUBEdit: true,
                            SUbCurrentData: subElement
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenAddSUBEdit: true,
                          SUbCurrentData: subElement
                        })
                      }
                    }}
                >
                  {/* <img src={edit} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} /> */}
                </span>
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement='auto'
              display={false}
              overlay={subElement.okasBox_status === 'expired' ? <div></div> : <Tooltip id="overlay-example">Assigned</Tooltip>}>
              <span className="d-inline-block">
                <span
                  // className="far fa-trash-alt fa-2x pull-right icon-button-si px-2 py-2"
                  style={{ pointerEvents: subElement.okasBox_status !== 'expired' ? 'none' : '', opacity: subElement.okasBox_status !== 'expired' ? '0.5' : '' }}
                  onClick={(e) => {
                    this.setState({
                      itemToDeleteId: subElement.okasBox_id,
                      modalIsOpenDelete: true
                    })
                  }}>
                  {/* <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} /> */}
                </span>
              </span>
            </OverlayTrigger>
          </td>
        </tr>
      })
      return someData;
    } else {
      return null
    }
  }
  numberOfBoxes = (boxState) => {
    let numberOfBoxType = 0;
    this.state.actualData.forEach((e) => {
      if (e.subscription_status === boxState) {
        numberOfBoxType = numberOfBoxType + 1;
      }
    })
    return numberOfBoxType
  }

  siNameHandler = (data, siId) => {
    let siName = 'Unassigned';
    data.forEach((element) => {
      if (Number(element.si_id) === Number(siId)) {
        siName = element.si_userName
      }
    })
    // console.log('siName:',data)
    return siName
  }


  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddSUB || this.state.modalIsOpenAddSUBView || this.state.modalIsOpenAddSUBEdit || this.state.modalIsOpenDeleteSuccess) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
  }


  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }


  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal('overlay')}
        <div style={{ paddingLeft: '-8px', paddingTop: '40px', paddingRight: '6px', height: `${window.innerHeight - 70}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px' }}>ALL SUBSCRIPTIONS</span>
            <span style={{ float: 'right' }}>

              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                {(
                  localStorage.getItem("user_type") === "1" ||
                  (
                    localStorage.getItem("user_type") === "2" &&
                    is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "subscription", "view")
                  )
                ) && (
                    <a href="./SubscriptionPlan">  {/* Path to redirect SubscriptionPlan plan */}

                      <div className="pointer"  >
                        <div className="buttonContent" style={{ backgroundColor: '#2976a7 ', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>

                          <span style={{ color: '#fff', fontSize: '10px', fontWeight: '600' }}>VIEW SUBSCRIPTIONSPLANS</span>
                        </div>
                      </div>
                    </a>)}
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar
              value=''
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            />
          </div>}
          {!this.props.redux.auth.searchBarShow ? <div class="d-flex">
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#be0101', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Subscriptions<br />Expired</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', borderRadius: "15px 15px 0px 0px" }} >{this.numberOfBoxes('expired')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#f6a200', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Subscriptions<br />About To Expire</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', }} >{this.numberOfBoxes('about_to_expire')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#46ad78', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Subscriptions<br />Active</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', }} >{this.numberOfBoxes('active')}</div>
                </div>
              </div>
            </div>
          </div> : null}
          <table className="table" style={{ marginTop: '30px' }}>
            <thead className="tableHeader" style={{ borderRadius: '10px 10px 0px 0px', backgroundColor: '#696969', color: '#fff' }}>
              {/* <th scope="col" style={{ width: '70px' }} >
                ID
                <i class={this.fetchIconType('okasBox_id')} onClick={(e) => { this.sortingFunc('okasBox_id') }}>
                </i>
              </th> */}
              <th scope="col" style={{ width: '70px', fontSize: '12px' }}>
                PROJECT NAME
                <i class={this.fetchIconType('okasBox_type')} onClick={(e) => { this.sortingFunc('okasBox_type') }}></i>
              </th>
              <th scope="col" style={{ width: '10%', fontSize: '12px' }}>
                PROJECT ADDRESS
                <i class={this.fetchIconType('user')} onClick={(e) => { this.sortingFunc('user') }}></i>
              </th>
              {/* <th scope="col" style={{ width: '150px', fontSize: '12px' }}>
                CLIENT EMAIL
                <i class={this.fetchIconType('okasBox_serialNo')} onClick={(e) => { this.sortingFunc('okasBox_serialNo') }}></i>
              </th> */}
              <th scope="col" style={{ width: '100px', fontSize: '12px' }}>
                EMAIL
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '60px', fontSize: '12px' }}>
                SI
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '100px', fontSize: '12px' }}>
                DISTRIBUTOR
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '90px', fontSize: '12px' }}>
                EXPIRY DATE
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '58px', fontSize: '12px' }}>
                STATUS
                {/* <i class={this.fetchIconType('okasBox_status')} onClick={(e) => { this.sortingFunc('okasBox_status') }}></i> */}
              </th>
              <th scope="col" style={{ width: '70px', fontSize: '12px', fontSize: '12px' }}>
                PAYMENT
                {/* <i class={this.fetchIconType('okasBox_status')} onClick={(e) => { this.sortingFunc('okasBox_status') }}></i> */}
              </th>
              <th scope="col" style={{ width: '45px', fontSize: '12px', fontSize: '12px' }}>
                VIEW
              </th>
            </thead>
            <tbody style={{ maxHeight: this.props.redux.auth.searchBarShow ? `${window.innerHeight - 200}px` : `${window.innerHeight - 400}px`, overflowY: 'overlay' }}>
              {this.subDatatable()}
            </tbody>
          </table>
          {/* <TablePagination /> */}
          {/* <div className="row p-0 m-0" >
          <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
          <div class="btn-group mr-2" role="group" aria-label="Third group">
              <button type="button" class="btn btn-secondary">
              <i class="fas fa-angle-double-left"></i>
              </button>
              <button type="button" class="btn btn-secondary">
              <i class="fas fa-angle-left"></i>
              </button>
            </div>
            <div class="btn-group mr-2" role="group" aria-label="First group">            
              {this.state.paginationTable.buttonArray.map((e,index)=>{
                return  <button type="button" class="btn btn-secondary">{index+1}</button>
              })}              
            </div>
            <div class="btn-group" role="group" aria-label="Third group">
              <button type="button" class="btn btn-secondary">
              <i class="fas fa-angle-right"></i>              
              </button>
              <button type="button" class="btn btn-secondary">
              <i class="fas fa-angle-double-right"></i>
              </button>
            </div>
          </div>
        </div> */}
        </div>
        {this.ActivateSUBModel()}
        {this.ActivateSUbModelView()}
        {this.ActivateSUbModelEdit()}
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion?</h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })
              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">OKAS Box deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
            }}>Close</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),

  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);